export default "__VITE_ASSET__k$ZWYmku__"